import React from "react"
import { randoms, OPERATORS } from "lib/utils"
import { apidata } from "../data/apidata"

// const operatorsMap = [
//   { orig: "exists", mapsTo: "mustExist" },
//   { orig: "unexists", mapsTo: "mustNotExist" },
//   { orig: "eq", mapsTo: "mustBe" },
//   { orig: "neq", mapsTo: "mustBeNot" },
//   { orig: "stricteq", mapsTo: "mustBeStrict" },
//   { orig: "strictneq", mapsTo: "mustNotBeStrict" },
//   { orig: "includes", mapsTo: "mustContain" },   // subject (api value) includes target (value sought)
//   { orig: "notincludes", mapsTo: "mustNotContain" },
//   { orig: "contains", mapsTo: "mustInclude" },    // subject (api value) must be a member of the target value
//   { orig: "notcontains", mapsTo: "mustNotInclude" },
// ]


export default function migrateConditional(originalData:any){

  function parsePlaceholderValue(originalPh:string){
    const found = apidata.find( (data:any) => data.placeholder === originalPh )
    if (!found ){
      console.log(`Placeholder ${originalPh} not found in apidata`)
      return originalPh // return original if not found
    }
    return `[[${found.path}]]` // return the path to the api value
  }

  function replacePlaceholders(str: string): string {
    return str.replace(/\{(.*?)\}/g, (_, key) => parsePlaceholderValue(key));
  }

  const convertOperator = (operator:string) => {
    const result = OPERATORS.find( (op:any) => op.orig === operator )?.value || null
    if(!result) {
      console.log(`Operator ${operator} not found in operatorsMap`)
    }
    return result
  }
  
  const getApiValueObj = (origPlaceholder:string) => {
    console.log(`searching for:`, origPlaceholder)
    const found = apidata.find( (data:any) => data.placeholder === origPlaceholder )
    if(!found){
      console.log(`No api value found for ${origPlaceholder}`)
      return null
    }
    return found
  }
  
  const makeConditionalItem = (conditional:any) => {
    console.log(`making conditional item for:`, conditional)
    const apiValueObj = getApiValueObj(conditional.subject)
    if( apiValueObj === null ){
      console.log(`No api value found for ${conditional.subject}. Cannot create conditional item.`)
      return null
    }
    console.log(`apiValueObj for ${conditional.subject}:`, apiValueObj)
    return {
      refid: randoms.string(12, "a#"),
      source: "api",
      api_value_id: apiValueObj._id,
      apiValueObj: apiValueObj, // get api value object 
      conversion: "none", // no conversion needed
      operator: convertOperator(conditional.operator), // convert to api value
      value: conditional.value,
      alias: `${conditional.subject} ${convertOperator(conditional.operator)} ${conditional.value}`,
      tag: "",
      location: "dropzone"
    }
  }
  
  
  const makeConditional = (conditionalArr:any) => {
    // each item must be in a separate group
    const refstr = randoms.string(12, "a#")

    let items:any[] = []
    let zone:any = { zoneref: randoms.string(12, "a#"), groups: []}

    if(!conditionalArr || conditionalArr.length === 0){
      console.log("No conditionals found.")
      return null
    }

    conditionalArr.map( (conditional:any) => {
      const item = makeConditionalItem(conditional)
      if(!item) {
        console.log(`Item for conditional ${conditional.subject} not created. Skipping...`)
        return null
      }
      const group = { "groupref": randoms.string(12, "a#"), "items": [item.refid] }
      items = [ ...items, item ] // add item to the zone's items array
      zone.groups = [ ...zone.groups, group ] // add group to the zone's groups array
    }) 

    return {
      refstr: refstr,
      source_id: null,
      name: "Conditional Statement",
      description: "",
      zones: [zone],
      items,
      clipboard: []
    }
  }

  /* === each segment is a statement in the new template === */
  const migrateSegment = (seg:any) => {
    console.log(`migrating segment:`, seg)
    return {
      refstr: randoms.string(12, "a#"),
      title: seg.type === 'content' ? 'Content Item' : 'Conditional Item',
      description: "",
      visible: true,
      parent: ["[root]"],
      parentResult: "any",
      level: 1,
      if_passes: "content",
      if_fails: "nothing",
      nested: { if_passes: null,  if_fails: null },
      conditional: seg.type === 'content' ? null : makeConditional(seg.conditions),
      content: { pass: replacePlaceholders(seg.value), fail: null }
    }
  }

  const statements = originalData.Segments.map( (seg:any) =>  migrateSegment(seg) )
  return statements
}